import React from "react"
import { useOutlet } from "react-router-dom"

export const Dashboards = () => {
  const outlet = useOutlet()
  return <>{outlet}</>
}
